export default "__VITE_ASSET__85dd90e8__"